import { AxiosError } from 'axios'
import { useForm } from 'react-hook-form'
import { Link, useNavigate } from 'react-router-dom'
import { yupResolver } from '@hookform/resolvers/yup'
import { loginSchema } from 'utils/schema/authSchema'
import { Button, TextInput } from 'components/common'
import {
  PAGE_DASHBOARD,
  PAGE_FORGOT_PASSWORD,
  ERROR_CODES,
} from 'utils/constants'
import { userLogin } from 'utils/api/auth'
import toast from 'react-hot-toast'

const { DISABLED_ACCOUNT, WRONG_PASSWORD, NOT_FOUND } = ERROR_CODES

export type LoginFormData = {
  email: string
  password: string
}

/**
 * Login Form Component
 */
const LoginForm = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<LoginFormData>({
    resolver: yupResolver(loginSchema),
  })

  const navigate = useNavigate()

  const onLogin = async (userData: LoginFormData) => {
    const loader = toast.loading('Attempting to login')
    try {
      await userLogin(userData)
      navigate(PAGE_DASHBOARD.path)
      toast.success('Login successfull', {
        id: loader,
      })
      localStorage.clear()
    } catch (error: AxiosError | any) {
      if (error instanceof AxiosError) {
        const MESSAGE = error.response?.data.errors?.msg
        if (MESSAGE === NOT_FOUND || MESSAGE === WRONG_PASSWORD) {
          toast.error('Invalid Email And Password', {
            id: loader,
          })
        } else if (MESSAGE === DISABLED_ACCOUNT) {
          toast.error('Account is disabled', {
            id: loader,
          })
        } else {
          toast.error('Some error occured', {
            id: loader,
          })
        }
      }
    }
  }

  return (
    <section className="w-full max-w-lg p-10">
      <div className="text-center">
        <h1 className="mb-1 text-4xl font-bold">Welcome Back</h1>
        <h3 className="text-base">Please enter your login details</h3>
      </div>
      <div className="mt-10 ">
        <form onSubmit={handleSubmit(onLogin)}>
          <div className="flex flex-col gap-2">
            <TextInput
              required
              type="text"
              name="email"
              label="Email"
              placeholder="Enter your email"
              register={register}
              error={errors?.email?.message}
            />
            <TextInput
              required
              register={register}
              name="password"
              label="Password"
              type="password"
              placeholder="Enter your password"
              error={errors?.password?.message}
            />
          </div>
          <Button buttonText="Login" className="mt-5 w-full" />
        </form>
        <Link
          to={PAGE_FORGOT_PASSWORD.path}
          className="mt-4 flex text-sm text-gray-600"
        >
          <div className="flex items-center gap-1">Forgot Password?</div>
        </Link>
      </div>
    </section>
  )
}

export default LoginForm
